module.exports = __webpack_public_path__ + "img/img16.9b590203.jpg";